export default new class indexComponent {
  constructor() {
    this.topSlider();
    this.loadOpportunities();
    setTimeout(() => {
      this.opportunitiesSlider();
    }, 1000);
  }

  // eslint-disable-next-line class-methods-use-this
  topSlider() {
    $('._top-slider').owlCarousel({
      autoplay: true,
      autoplayTimeout: 4000,
      smartSpeed: 1000,
      margin: 15,
      loop: true,
      items: 1,
      nav: true,
      dots: true,
      navText: [
        '<div class="prev-top-slider"></div>',
        '<div class="next-top-slider"></div>',
      ],
    });
  }

  loadOpportunities() {
    if ($(document).width() <= 768) {
      this.opportunitiesPatrial = 'content/index-opportunities-mobile';
    } else {
      this.opportunitiesPatrial = 'content/index-opportunities-desktop';
    }
    $.request('onAjax', {
      update: {
        [this.opportunitiesPatrial]: '._opportunities',
      },
      success(res) {
        this.success(res);
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  opportunitiesSlider() {
    $('._opportunities-slider').owlCarousel({
      smartSpeed: 500,
      margin: 15,
      loop: true,
      dots: true,
      items: 1,
      nav: false,
    });
  }
}();
